import React from 'react'
import { InfoList, InfoListWrapper } from './MyProfilePageStyled'
import { inject, observer } from 'mobx-react'
import { EmptyText } from '../../components/Common/CellText'

const Education = props => {
  const { authenticationStore } = props

  const { currentUser } = authenticationStore
  const nullText = <EmptyText>Chưa cập nhật</EmptyText>

  return (
    <InfoListWrapper>
      <InfoList>
        <dt>Trình độ giáo dục phổ thông</dt>
        <dd>{currentUser?.other?.education_level || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Trình độ chuyên môn cao nhất</dt>
        <dd>{currentUser?.other?.qualification || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Lý luận chính trị</dt>
        <dd>{currentUser?.other?.political_theory || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Tin học</dt>
        <dd>{currentUser?.other?.IT || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngoại ngữ</dt>
        <dd>{currentUser?.other?.foreign_language || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Quản lý nhà nước</dt>
        <dd>{currentUser?.other?.state_management || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Khen thưởng</dt>
        <dd>{currentUser?.other?.laudatory || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Kỷ luật</dt>
        <dd>{currentUser?.other?.discipline || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày vào Đảng Cộng sản Việt Nam</dt>
        <dd>{currentUser?.other?.join_date || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày chính thức</dt>
        <dd>{currentUser?.other?.official_date || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày tham gia tổ chức chính trị xã hội</dt>
        <dd>{currentUser?.other?.join_political || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày nhập ngũ</dt>
        <dd>{currentUser?.other?.date_of_enlistment || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Ngày xuất ngũ</dt>
        <dd>{currentUser?.other?.demobilization_date || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Quân hàm cao nhất</dt>
        <dd>{currentUser?.other?.army_rank || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Sở trường công tác</dt>
        <dd>{currentUser?.other?.forte || nullText}</dd>
      </InfoList>
      <InfoList>
        <dt>Danh hiệu được phong tặng cao nhất</dt>
        <dd>{currentUser?.other?.title || nullText}</dd>
      </InfoList>
    </InfoListWrapper>
  )
}

Education.propTypes = {}

export default inject('authenticationStore')(observer(Education))
